export const LoginMode = {
  login: 'login',
  signup: 'signup',
  forgotPassword: 'forgotPassword',
};
